module.exports = __webpack_public_path__ + "static/media/gg_dark_text.a06aa81b.png";